import { render, staticRenderFns } from "./RescuesUpdate.vue?vue&type=template&id=3a6cec59&"
import script from "./RescuesUpdate.vue?vue&type=script&lang=js&"
export * from "./RescuesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports